import { useEffect, useMemo, useState } from 'react';
import {
  Box,
  Typography,
  IconButton,
  Button,
  useMediaQuery,
  Grid,
  Card,
} from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import { Link as RouterLink } from 'react-router-dom';
import DescriptionIcon from '@mui/icons-material/Description';
import PageSeo, {
  absoluteUrl,
  keywordSets,
  localBusinessJsonLd,
  websiteJsonLd,
} from './PageSeo';
import img1 from './Asset/1.webp';
import img2 from './images/sealion-banner.webp';
import img3 from './Asset/3.webp';
import img4 from './Asset/4.webp';
import mobile1 from './Asset/4cars-home-mobile.webp';
import mobile2 from './Asset/Atto3-Mobile.webp';
import atto from './Asset/byd-atto3.webp';
import dolphin from './Asset/byd-dolphin.webp';
import seagull from './images/07-01-pc-01.webp';
import b5 from './Gallery/b5-header.webp';
import m6 from './Asset/byd-m6.webp';
import m6dm from './images/bydm6dm/menu-1.webp';
import seal from './Asset/byd-seal.webp';
import denzad9 from './Asset/banner-DenzaD9.webp';
import sealion7 from './Asset/byd-sealion-7.webp';
import profileImg from './images/marketingjpg.jpg';
import img5 from './Asset/banner-DenzaD9.webp';
import mobile4 from './Asset/denzad9-banner-mob.webp';
import img6 from './Asset/atto1byd.webp';
import mobile5 from './Gallery/B5-Desktop-1.webp';
import m6dmPrebook from './images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.24 AM.jpeg';
import m6dmTechnology from './images/bydm6dm/WhatsApp Image 2026-05-18 at 8.49.42 AM.jpeg';

const Body = () => {
  const [carouselIndex, setCarouselIndex] = useState(1);
  const [isCarouselTransitioning, setIsCarouselTransitioning] = useState(true);
  const isMobile = useMediaQuery('(max-width:600px)');

  const desktopSlides = useMemo(
    () => [
      {
        src: m6dmTechnology,
        alt: 'BYD M6 DM Dual Mode Technology di BYD BSD Serpong',
      },
      {
        src: img1,
        alt: 'Dealer BYD BSD Serpong untuk harga mobil listrik BYD dan test drive',
      },
      {
        src: img5,
        alt: 'Denza D9 di BYD BSD Serpong untuk MPV listrik premium',
      },
      {
        src: img6,
        alt: 'BYD Atto 1 city car listrik untuk mobilitas harian',
      },
      {
        src: img4,
        alt: 'Promo dan konsultasi pembelian mobil listrik BYD BSD Serpong',
      },
      {
        src: img3,
        alt: 'Pilihan model BYD untuk keluarga dan harian di Tangerang Selatan',
      },
      {
        src: img2,
        alt: 'BYD Sealion 7 SUV listrik tersedia di BYD BSD Serpong',
      },
    ],
    [],
  );

  const mobileSlides = useMemo(
    () => [
      {
        src: m6dmPrebook,
        alt: 'Pre-book BYD M6 DM di BYD BSD Serpong',
      },
      {
        src: mobile1,
        alt: 'Dealer BYD BSD Serpong untuk test drive mobil listrik BYD',
      },
      {
        src: mobile4,
        alt: 'Denza D9 MPV listrik premium di BYD BSD Serpong',
      },
      {
        src: mobile5,
        alt: 'Denza B5 tersedia untuk konsultasi di BYD BSD Serpong',
      },
      {
        src: mobile2,
        alt: 'BYD Atto 3 SUV listrik untuk Tangerang Selatan',
      },
    ],
    [],
  );

  const slides = useMemo(
    () => (isMobile ? mobileSlides : desktopSlides),
    [desktopSlides, isMobile, mobileSlides],
  );

  const carouselSlides = useMemo(
    () => [slides[slides.length - 1], ...slides, slides[0]],
    [slides],
  );

  useEffect(() => {
    setIsCarouselTransitioning(false);
    setCarouselIndex(1);
  }, [slides.length]);

  const handlePrev = () => {
    setIsCarouselTransitioning(true);
    setCarouselIndex((prev) => prev - 1);
  };

  const handleNext = () => {
    setIsCarouselTransitioning(true);
    setCarouselIndex((prev) => prev + 1);
  };

  const handleCarouselTransitionEnd = () => {
    if (carouselIndex === carouselSlides.length - 1) {
      setIsCarouselTransitioning(false);
      setCarouselIndex(1);
    }

    if (carouselIndex === 0) {
      setIsCarouselTransitioning(false);
      setCarouselIndex(slides.length);
    }
  };

  const brochures = [
    {
      name: 'BYD Atto 1',
      file: `${process.env.PUBLIC_URL}/files/FA_FLYERATTO1FINALB.pdf`,
    },
    {
      name: 'BYD Dolphin',
      file: `${process.env.PUBLIC_URL}/files/Byd dolphin.pdf`,
    },
    {
      name: 'BYD Atto 3',
      file: `${process.env.PUBLIC_URL}/files/FA_FLYER_ATTO_2025(AdvSTD-Superior).pdf`,
    },
    { name: 'BYD M6', file: `${process.env.PUBLIC_URL}/files/Byd m6.pdf` },
    {
      name: 'BYD Sealion 7',
      file: `${process.env.PUBLIC_URL}/files/FA_BROCHURE_SEALION7_12-compressed_1.pdf`,
    },
    {
      name: 'BYD Seal',
      file: `${process.env.PUBLIC_URL}/files/FA_FLYER_SEAL_2025.pdf`,
    },
    {
      name: 'BYD Denza D9',
      file: `${process.env.PUBLIC_URL}/files/DOC-20250122-WA0016._20250122_102210_0000.pdf`,
    },
  ];
  const allCars = [
    {
      title: 'BYD M6 DM',
      img: m6dm,
      desc: 'MPV plug-in hybrid Dual Mode dengan range panjang untuk keluarga dan perjalanan jauh.',
      path: '/jelajahi-m6-dm',
      tag: 'MPV PHEV',
      isNew: true,
    },
    {
      title: 'BYD Dolphin',
      img: dolphin,
      desc: 'Hatchback listrik ringkas untuk harian, efisien, praktis, dan nyaman untuk rute kota.',
      path: '/jelajahi-dolphin',
      tag: 'Hatchback EV',
    },
    {
      title: 'BYD ATTO 3',
      img: atto,
      desc: 'SUV listrik stylish dengan kabin nyaman, fitur lengkap, dan karakter berkendara halus.',
      path: '/jelajahi-atto',
      tag: 'SUV EV',
    },
    {
      title: 'Denza B5',
      img: b5,
      desc: 'SUV premium dengan tenaga besar, torsi instan, dan karakter kuat untuk berbagai perjalanan.',
      path: '/jelajahi-b5',
      tag: 'SUV Premium',
      isNew: true,
    },
    {
      title: 'BYD Seal',
      img: seal,
      desc: 'Sedan listrik elegan dengan desain aerodinamis, performa responsif, dan rasa berkendara premium.',
      path: '/jelajahi-seal',
      tag: 'Sedan EV',
    },
    {
      title: 'BYD ATTO 1',
      img: seagull,
      desc: 'City car listrik kompak dan efisien untuk aktivitas harian di area Jabodetabek.',
      path: '/jelajahi-atto1',
      tag: 'City Car EV',
      isNew: true,
    },
    {
      title: 'Denza D9',
      img: denzad9,
      desc: 'MPV listrik premium dengan kabin lega, kenyamanan kelas atas, dan fitur keluarga lengkap.',
      path: '/jelajahi-denzad9',
      tag: 'MPV Premium',
    },
    {
      title: 'BYD SEALION 7',
      img: sealion7,
      desc: 'SUV listrik sporty dengan teknologi modern, jarak tempuh jauh, dan performa bertenaga.',
      path: '/jelajahi-sealion-7',
      tag: 'Sport SUV EV',
    },
    {
      title: 'BYD M6',
      img: m6,
      desc: 'MPV listrik 7-seater untuk keluarga, perjalanan harian, dan kebutuhan mobilitas praktis.',
      path: '/jelajahi-m6',
      tag: 'MPV 7-Seater',
    },
  ];

  const featuredCars = allCars.filter((car) =>
    ['BYD ATTO 1', 'BYD M6 DM', 'BYD M6', 'BYD SEALION 7', 'Denza D9'].includes(car.title),
  );

  const quickStats = [
    { value: 'BYD & Denza', label: 'pilihan model resmi' },
    { value: 'BSD Serpong', label: 'area konsultasi dan test drive' },
    { value: 'Junius', label: 'kontak langsung sales BYD BSD' },
  ];

  const serviceHighlights = [
    {
      title: 'Konsultasi Model',
      text: 'Bandingkan BYD Atto 1, Dolphin, Atto 3, M6, M6 DM, Sealion 7, Denza D9, dan Denza B5 sesuai kebutuhan Anda.',
    },
    {
      title: 'Info Harga dan Promo',
      text: 'Dapatkan arahan harga OTR, simulasi pembiayaan, promo berjalan, dan estimasi ketersediaan unit.',
    },
    {
      title: 'Test Drive BYD BSD',
      text: 'Atur jadwal test drive agar Anda bisa merasakan langsung kabin, akselerasi, fitur, dan kenyamanan mobil.',
    },
  ];

  const buyingSteps = [
    'Konsultasi kebutuhan mobil dan budget bersama Junius.',
    'Pilih model BYD atau Denza, warna, varian, dan skema pembayaran.',
    'Jadwalkan test drive di BYD BSD Serpong bila unit tersedia.',
    'Lanjutkan proses pemesanan, dokumen, dan serah terima unit.',
  ];

  const homeFaqs = [
    {
      question: 'Apakah bisa test drive BYD di BSD Serpong?',
      answer:
        'Bisa. Hubungi Junius untuk cek jadwal test drive dan ketersediaan unit BYD atau Denza di BYD BSD Serpong.',
    },
    {
      question: 'Model BYD apa saja yang bisa dikonsultasikan?',
      answer:
        'Anda bisa konsultasi BYD Atto 1, Dolphin, Atto 3, M6, M6 DM, Seal, Sealion 7, Denza D9, dan Denza B5.',
    },
    {
      question: 'Apakah bisa minta info harga BYD terbaru?',
      answer:
        'Bisa. Harga, promo, dan skema pembiayaan dapat berubah, jadi Junius akan bantu cek info OTR dan promo yang sedang berjalan.',
    },
  ];

  const itemListJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Model mobil listrik BYD dan Denza di BYD BSD Serpong',
    itemListElement: allCars.map((car, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: car.title,
      url: absoluteUrl(car.path),
      image: absoluteUrl(car.img),
      description: car.desc,
    })),
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: homeFaqs.map((faq) => ({
      '@type': 'Question',
      name: faq.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: faq.answer,
      },
    })),
  };

  return (
    <>
      <PageSeo
        title='BYD BSD Serpong | Dealer Resmi BYD Tangerang Selatan'
        description='Dealer resmi BYD BSD Serpong untuk harga BYD terbaru, promo, test drive, dan konsultasi pembelian mobil listrik bersama Junius.'
        keywords={[
          ...keywordSets.localDealer,
          'mobil listrik BYD Tangerang',
          'mobil listrik BYD BSD Serpong',
          'harga BYD terbaru',
          'promo BYD Tangerang Selatan',
          'sales BYD BSD',
          'showroom BYD BSD City',
          'test drive mobil listrik BYD',
        ]}
        path='/'
        image={img1}
        jsonLd={[
          localBusinessJsonLd(),
          websiteJsonLd(),
          itemListJsonLd,
          faqJsonLd,
        ]}
      />

      <Box component='main'>
        {/* Carousel Section */}
        <Box
          component='section'
          aria-label='Dealer resmi BYD BSD Serpong'
          sx={{
            position: 'relative',
            width: '100%',
            minHeight: { xs: 520, sm: 560, md: 620 },
            height: { xs: 'calc(100svh - 72px)', sm: '76vh', md: '82vh' },
            maxHeight: 760,
            overflow: 'hidden',
          }}
        >
          <Box
            onTransitionEnd={handleCarouselTransitionEnd}
            sx={{
              display: 'flex',
              width: `${carouselSlides.length * 100}vw`,
              transform: `translateX(-${carouselIndex * 100}vw)`,
              transition: isCarouselTransitioning
                ? 'transform 0.5s ease-in-out'
                : 'none',
              height: '100%',
            }}
          >
            {carouselSlides.map((slide, index) => (
              <Box
                key={index}
                component='img'
                src={slide.src}
                alt={slide.alt}
                sx={{ width: '100vw', height: '100%', objectFit: 'cover' }}
              />
            ))}
          </Box>
          <Box
            sx={{
              position: 'absolute',
              inset: 0,
              background: {
                xs: 'linear-gradient(180deg, rgba(10,15,20,0.72) 0%, rgba(10,15,20,0.46) 48%, rgba(10,15,20,0.2) 100%)',
                md: 'linear-gradient(90deg, rgba(10,15,20,0.74) 0%, rgba(10,15,20,0.45) 45%, rgba(10,15,20,0.1) 100%)',
              },
              pointerEvents: 'none',
            }}
          />
          <Box
            sx={{
              position: 'absolute',
              left: { xs: 18, sm: 32, md: 72 },
              right: { xs: 18, sm: 32, md: '44%' },
              top: { xs: 76, sm: 108, md: 138 },
              color: '#fff',
              zIndex: 1,
            }}
          >
            <Typography
              sx={{
                display: 'inline-flex',
                px: { xs: 1.1, md: 1.4 },
                py: { xs: 0.55, md: 0.7 },
                mb: { xs: 1.4, md: 2 },
                borderRadius: '8px',
                backgroundColor: 'rgba(255,255,255,0.16)',
                border: '1px solid rgba(255,255,255,0.28)',
                fontSize: { xs: '0.72rem', md: '0.82rem' },
                fontWeight: 900,
                letterSpacing: 0.4,
                textTransform: 'uppercase',
              }}
            >
              BYD BSD Serpong
            </Typography>
            <Typography
              variant='h1'
              component='h1'
              sx={{
                fontWeight: 900,
                lineHeight: { xs: 1.03, md: 1 },
                fontSize: { xs: '2rem', sm: '3rem', md: '4.5rem' },
                maxWidth: { xs: 330, md: 720 },
              }}
            >
              Dealer Mobil Listrik BYD di Tangerang Selatan
            </Typography>
            <Typography
              sx={{
                mt: { xs: 1.4, md: 2 },
                maxWidth: { xs: 320, md: 650 },
                color: 'rgba(255,255,255,0.86)',
                lineHeight: { xs: 1.5, md: 1.75 },
                fontSize: { xs: '0.94rem', md: '1.1rem' },
              }}
            >
              Konsultasi harga BYD terbaru, promo, pilihan varian, test drive,
              dan proses pembelian bersama Junius di BYD BSD Serpong.
            </Typography>
            <Box
              sx={{
                display: 'flex',
                flexWrap: { xs: 'nowrap', sm: 'wrap' },
                gap: { xs: 1, md: 1.5 },
                mt: { xs: 2, md: 3 },
                maxWidth: { xs: 330, md: 'none' },
                '& .MuiButton-root': {
                  minWidth: 0,
                },
              }}
            >
              <Button
                component={RouterLink}
                to='/pricing'
                variant='contained'
                sx={{
                  borderRadius: '8px',
                  px: { xs: 1.7, md: 3 },
                  py: { xs: 0.95, md: 1.15 },
                  fontSize: { xs: '0.88rem', md: '0.95rem' },
                  fontWeight: 900,
                  textTransform: 'none',
                  backgroundColor: '#2d6cdf',
                  '&:hover': { backgroundColor: '#1f5fc8' },
                }}
              >
                Lihat Harga BYD
              </Button>
              <Button
                component='a'
                href='https://wa.me/6281286864825'
                target='_blank'
                rel='noopener noreferrer'
                variant='outlined'
                sx={{
                  borderRadius: '8px',
                  px: { xs: 1.7, md: 3 },
                  py: { xs: 0.95, md: 1.15 },
                  fontSize: { xs: '0.88rem', md: '0.95rem' },
                  fontWeight: 900,
                  textTransform: 'none',
                  color: '#fff',
                  borderColor: 'rgba(255,255,255,0.72)',
                  '&:hover': {
                    borderColor: '#fff',
                    backgroundColor: 'rgba(255,255,255,0.12)',
                  },
                }}
              >
                Chat Junius
              </Button>
            </Box>
          </Box>
          <IconButton
            onClick={handlePrev}
            aria-label='Slide sebelumnya'
            sx={{
              position: 'absolute',
              top: { xs: 'auto', md: '50%' },
              bottom: { xs: 18, md: 'auto' },
              left: { xs: 14, md: 10 },
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.5)',
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton
            onClick={handleNext}
            aria-label='Slide berikutnya'
            sx={{
              position: 'absolute',
              top: { xs: 'auto', md: '50%' },
              bottom: { xs: 18, md: 'auto' },
              right: { xs: 14, md: 10 },
              color: '#fff',
              backgroundColor: 'rgba(0,0,0,0.5)',
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>
        </Box>

        <Box
          component='section'
          aria-label='Ringkasan layanan BYD BSD Serpong'
          sx={{
            px: { xs: 2, md: 6 },
            py: { xs: 4, md: 5 },
            backgroundColor: '#fff',
          }}
        >
          <Box
            sx={{
              maxWidth: 1180,
              mx: 'auto',
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: 'repeat(3, 1fr)' },
              gap: 2,
            }}
          >
            {quickStats.map((stat) => (
              <Box
                key={stat.value}
                sx={{
                  border: '1px solid rgba(17,24,39,0.08)',
                  borderRadius: '8px',
                  p: { xs: 2, md: 2.5 },
                  backgroundColor: '#f8fafc',
                }}
              >
                <Typography
                  component='strong'
                  sx={{
                    display: 'block',
                    fontSize: { xs: '1.35rem', md: '1.55rem' },
                    fontWeight: 900,
                    color: '#111827',
                    lineHeight: 1.1,
                  }}
                >
                  {stat.value}
                </Typography>
                <Typography sx={{ mt: 0.8, color: '#4b5563' }}>
                  {stat.label}
                </Typography>
              </Box>
            ))}
          </Box>
        </Box>

        {/* Auto Scroll Section */}
        <Box
          id='model-byd'
          component='section'
          aria-labelledby='model-byd-title'
          sx={{
            px: { xs: 2, sm: 4 },
            py: { xs: 5, md: 6 },
            backgroundColor: '#f5f7fa',
            position: 'relative',
            overflowX: 'hidden',
          }}
        >
          <Box sx={{ maxWidth: 1180, mx: 'auto', mb: 3 }}>
            <Typography
              id='model-byd-title'
              component='h2'
              sx={{
                fontSize: { xs: '1.8rem', md: '2.45rem' },
                fontWeight: 900,
                color: '#111827',
                lineHeight: 1.12,
              }}
            >
              Pilihan Mobil Listrik BYD dan Denza
            </Typography>
            <Typography
              sx={{
                mt: 1,
                color: '#4b5563',
                maxWidth: 760,
                lineHeight: 1.7,
              }}
            >
              Jelajahi model yang tersedia untuk kebutuhan harian, keluarga,
              perjalanan bisnis, dan mobilitas premium di area BSD Serpong.
            </Typography>
          </Box>
          {/* Manual Buttons */}
          <IconButton
            onClick={() => {
              const container = document.getElementById('scrollable-cars');
              container?.scrollBy({ left: -300, behavior: 'smooth' });
            }}
            aria-label='Geser model ke kiri'
            sx={{
              position: 'absolute',
              top: { xs: '58%', md: '56%' },
              left: 0,
              zIndex: 1,
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0,0,0,0.4)',
              color: '#fff',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
            }}
          >
            <ArrowBackIosIcon />
          </IconButton>
          <IconButton
            onClick={() => {
              const container = document.getElementById('scrollable-cars');
              container?.scrollBy({ left: 300, behavior: 'smooth' });
            }}
            aria-label='Geser model ke kanan'
            sx={{
              position: 'absolute',
              top: { xs: '58%', md: '56%' },
              right: 0,
              zIndex: 1,
              transform: 'translateY(-50%)',
              backgroundColor: 'rgba(0,0,0,0.4)',
              color: '#fff',
              '&:hover': { backgroundColor: 'rgba(0,0,0,0.7)' },
            }}
          >
            <ArrowForwardIosIcon />
          </IconButton>

          {/* Scrollable container */}
          <Box
            id='scrollable-cars'
            sx={{
              overflowX: 'auto',
              scrollBehavior: 'smooth',
              py: 2,
              '&::-webkit-scrollbar': { display: 'none' },
            }}
          >
            <Box
              sx={{
                display: 'flex',
                gap: 3,
                width: 'max-content',
                animation: 'scrollLeft 60s linear infinite',
                '&:hover': { animationPlayState: 'paused' },
              }}
            >
              {[...allCars, ...allCars].map((car, idx) => (
                <Box
                  key={`${car.title}-${idx}`}
                  component={RouterLink}
                  to={car.path}
                  aria-hidden={idx >= allCars.length ? 'true' : undefined}
                  tabIndex={idx >= allCars.length ? -1 : 0}
                  sx={{
                    flex: '0 0 auto',
                    width: { xs: 250, sm: 280 },
                    minHeight: 315,
                    display: 'flex',
                    flexDirection: 'column',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    border: '1px solid rgba(17,24,39,0.08)',
                    boxShadow: '0 12px 26px rgba(16,24,40,0.08)',
                    overflow: 'hidden',
                    cursor: 'pointer',
                    color: 'inherit',
                    textDecoration: 'none',
                    transition: 'transform 0.3s, box-shadow 0.3s',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 18px 34px rgba(16,24,40,0.13)',
                    },
                    position: 'relative',
                  }}
                >
                  {car.isNew && (
                    <Box
                      sx={{
                        position: 'absolute',
                        top: 8,
                        left: 8,
                        backgroundColor: '#e53935',
                        color: '#fff',
                        fontSize: 12,
                        fontWeight: 'bold',
                        px: 1,
                        py: 0.3,
                        borderRadius: '4px',
                        zIndex: 2,
                        animation: 'blinker 1s linear infinite',
                        boxShadow: '0 0 8px rgba(255,0,0,0.6)',
                      }}
                    >
                      HOT! NEW!
                    </Box>
                  )}

                  <Box
                    component='img'
                    src={car.img}
                    alt={`${car.title} di BYD BSD Serpong`}
                    loading='lazy'
                    sx={{
                      width: '100%',
                      height: 168,
                      flex: '0 0 auto',
                      objectFit: 'cover',
                    }}
                  />
                  <Box
                    sx={{
                      p: 2,
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography
                      sx={{
                        mb: 0.8,
                        color: '#2d6cdf',
                        fontSize: '0.78rem',
                        fontWeight: 900,
                        textTransform: 'uppercase',
                      }}
                    >
                      {car.tag}
                    </Typography>
                    <Typography variant='subtitle1' fontWeight='bold'>
                      {car.title}
                    </Typography>
                    <Typography
                      variant='body2'
                      sx={{
                        mt: 1,
                        color: '#4b5563',
                        lineHeight: 1.45,
                        overflowWrap: 'break-word',
                      }}
                    >
                      {car.desc}
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          component='section'
          aria-labelledby='unggulan-byd-title'
          sx={{
            px: { xs: 2, md: 6 },
            py: { xs: 5, md: 7 },
            backgroundColor: '#fff',
          }}
        >
          <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: { xs: 'flex-start', md: 'end' },
                flexDirection: { xs: 'column', md: 'row' },
                gap: 2,
                mb: 3,
              }}
            >
              <Box>
                <Typography
                  id='unggulan-byd-title'
                  component='h2'
                  sx={{
                    fontSize: { xs: '1.8rem', md: '2.45rem' },
                    fontWeight: 900,
                    color: '#111827',
                    lineHeight: 1.12,
                  }}
                >
                  Model Unggulan di BYD BSD Serpong
                </Typography>
                <Typography
                  sx={{
                    mt: 1,
                    color: '#4b5563',
                    maxWidth: 720,
                    lineHeight: 1.7,
                  }}
                >
                  Mulai dari city car listrik sampai MPV premium, pilih model
                  yang paling pas untuk aktivitas Anda.
                </Typography>
              </Box>
              <Button
                component={RouterLink}
                to='/pricing'
                variant='outlined'
                sx={{
                  borderRadius: '8px',
                  textTransform: 'none',
                  fontWeight: 900,
                  px: 2.5,
                  borderColor: '#2d6cdf',
                  color: '#2d6cdf',
                  '&:hover': {
                    borderColor: '#1f5fc8',
                    backgroundColor: '#edf4ff',
                  },
                }}
              >
                Bandingkan Harga
              </Button>
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: {
                  xs: '1fr',
                  sm: '1fr 1fr',
                  lg: 'repeat(4, 1fr)',
                },
                gap: 2.5,
              }}
            >
              {featuredCars.map((car) => (
                <Box
                  key={car.title}
                  component={RouterLink}
                  to={car.path}
                  sx={{
                    minHeight: 360,
                    display: 'flex',
                    flexDirection: 'column',
                    overflow: 'hidden',
                    borderRadius: '8px',
                    border: '1px solid rgba(17,24,39,0.08)',
                    backgroundColor: '#fff',
                    color: 'inherit',
                    textDecoration: 'none',
                    boxShadow: '0 12px 28px rgba(16,24,40,0.08)',
                    transition: 'transform 0.25s ease, box-shadow 0.25s ease',
                    '&:hover': {
                      transform: 'translateY(-4px)',
                      boxShadow: '0 18px 36px rgba(16,24,40,0.13)',
                    },
                  }}
                >
                  <Box
                    component='img'
                    src={car.img}
                    alt={`${car.title} model unggulan BYD BSD Serpong`}
                    loading='lazy'
                    sx={{
                      width: '100%',
                      height: 190,
                      objectFit: 'cover',
                    }}
                  />
                  <Box
                    sx={{
                      p: 2.2,
                      flex: 1,
                      display: 'flex',
                      flexDirection: 'column',
                    }}
                  >
                    <Typography
                      sx={{
                        color: '#2d6cdf',
                        fontSize: '0.78rem',
                        fontWeight: 900,
                        textTransform: 'uppercase',
                      }}
                    >
                      {car.tag}
                    </Typography>
                    <Typography
                      component='h3'
                      sx={{
                        mt: 0.7,
                        fontSize: '1.25rem',
                        fontWeight: 900,
                        color: '#111827',
                        lineHeight: 1.18,
                      }}
                    >
                      {car.title}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 1,
                        color: '#4b5563',
                        lineHeight: 1.6,
                        fontSize: '0.95rem',
                      }}
                    >
                      {car.desc}
                    </Typography>
                    <Typography
                      sx={{
                        mt: 'auto',
                        pt: 2,
                        color: '#11805a',
                        fontWeight: 900,
                      }}
                    >
                      Lihat detail model
                    </Typography>
                  </Box>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          component='section'
          aria-labelledby='layanan-byd-title'
          sx={{
            px: { xs: 2, md: 6 },
            py: { xs: 5, md: 7 },
            backgroundColor: '#eef5f2',
          }}
        >
          <Box
            sx={{
              maxWidth: 1180,
              mx: 'auto',
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '0.9fr 1.1fr' },
              gap: { xs: 3, md: 5 },
              alignItems: 'start',
            }}
          >
            <Box>
              <Typography
                id='layanan-byd-title'
                component='h2'
                sx={{
                  fontSize: { xs: '1.8rem', md: '2.35rem' },
                  fontWeight: 900,
                  color: '#111827',
                  lineHeight: 1.12,
                }}
              >
                Konsultasi BYD Lebih Mudah dengan Junius
              </Typography>
              <Typography sx={{ mt: 1.5, color: '#4b5563', lineHeight: 1.75 }}>
                Halaman ini dibuat untuk membantu calon pembeli menemukan info
                penting secara cepat: harga BYD, promo, test drive, brosur, dan
                pilihan model yang cocok untuk kebutuhan di Tangerang Selatan.
              </Typography>
              <Button
                component='a'
                href='https://wa.me/6281286864825'
                target='_blank'
                rel='noopener noreferrer'
                variant='contained'
                sx={{
                  mt: 3,
                  borderRadius: '8px',
                  px: 3,
                  py: 1.1,
                  textTransform: 'none',
                  fontWeight: 900,
                  backgroundColor: '#11805a',
                  '&:hover': { backgroundColor: '#0d6a4b' },
                }}
              >
                Tanya Promo dan Test Drive
              </Button>
            </Box>

            <Box
              sx={{
                display: 'grid',
                gridTemplateColumns: { xs: '1fr', sm: '1fr 1fr' },
                gap: 2,
              }}
            >
              {serviceHighlights.map((item) => (
                <Box
                  key={item.title}
                  sx={{
                    minHeight: 170,
                    p: 2.5,
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    border: '1px solid rgba(17,24,39,0.08)',
                  }}
                >
                  <Typography
                    component='h3'
                    sx={{
                      fontSize: '1.08rem',
                      fontWeight: 900,
                      color: '#111827',
                    }}
                  >
                    {item.title}
                  </Typography>
                  <Typography
                    sx={{
                      mt: 1,
                      color: '#4b5563',
                      lineHeight: 1.65,
                      fontSize: '0.95rem',
                    }}
                  >
                    {item.text}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        {/* Personal Section */}
        <Box
          component='section'
          aria-labelledby='junius-byd-title'
          sx={{
            px: { xs: 2, md: 10 },
            py: { xs: 5, md: 7 },
            backgroundColor: '#f8fafc',
          }}
        >
          <Box
            sx={{
              maxWidth: 1180,
              mx: 'auto',
              display: 'flex',
              flexDirection: { xs: 'column', md: 'row' },
              alignItems: 'center',
              gap: 4,
            }}
          >
            <Box
              component='img'
              src={profileImg}
              alt='Junius sales BYD BSD Serpong'
              loading='lazy'
              sx={{
                width: { xs: '100%', md: 330 },
                maxHeight: 430,
                objectFit: 'cover',
                borderRadius: '8px',
              }}
            />
            <Box>
              <Typography
                id='junius-byd-title'
                component='h2'
                sx={{
                  fontSize: { xs: '1.65rem', md: '2rem' },
                  fontWeight: 900,
                  lineHeight: 1.18,
                  color: '#111827',
                  mb: 1,
                }}
              >
                Tentang Saya - Junius, Marketing Mobil Listrik BYD BSD
              </Typography>
              <Typography
                fontStyle='italic'
                color='text.secondary'
                gutterBottom
              >
                Selamat datang di BYD BSD Serpong, pusat mobil listrik ramah
                lingkungan. Saya Junius siap bantu Anda mendapatkan kendaraan
                BYD terbaik yang sesuai kebutuhan dan gaya hidup Anda.
              </Typography>
              <Typography paragraph>
                Sebagai spesialis marketing mobil listrik BYD di Tangerang, saya
                berkomitmen memberikan pengalaman terbaik bagi setiap calon
                pembeli. Saya akan membantu Anda memilih model BYD seperti Atto
                3, Dolphin, atau Sealion 7 yang tepat untuk kebutuhan mobilitas
                Anda.
              </Typography>
              <Typography paragraph fontWeight='bold'>
                Jangan ragu untuk hubungi saya langsung:
              </Typography>
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}
              >
                <WhatsAppIcon sx={{ color: '#25D366' }} />
                <a
                  href='https://wa.me/6281286864825'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: '#000', textDecoration: 'none' }}
                >
                  +62 812 8686 4825
                </a>
              </Box>
              <Box
                sx={{ display: 'flex', alignItems: 'center', gap: 2, mt: 1 }}
              >
                <InstagramIcon sx={{ color: '#E1306C' }} />
                <a
                  href='https://instagram.com/bydbsdserpong'
                  target='_blank'
                  rel='noopener noreferrer'
                  style={{ color: '#000', textDecoration: 'none' }}
                >
                  @bydbsdserpong
                </a>
              </Box>
              <Typography paragraph sx={{ mt: 2 }}>
                Bersama BYD, mari kita ciptakan masa depan berkendara yang lebih
                hijau, efisien, dan canggih di Indonesia.
              </Typography>
            </Box>
          </Box>
        </Box>

        <Box
          component='section'
          aria-labelledby='proses-byd-title'
          sx={{
            px: { xs: 2, md: 6 },
            py: { xs: 5, md: 7 },
            backgroundColor: '#fff',
          }}
        >
          <Box
            sx={{
              maxWidth: 1180,
              mx: 'auto',
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', md: '0.8fr 1.2fr' },
              gap: { xs: 3, md: 5 },
              alignItems: 'start',
            }}
          >
            <Box>
              <Typography
                id='proses-byd-title'
                component='h2'
                sx={{
                  fontSize: { xs: '1.75rem', md: '2.3rem' },
                  fontWeight: 900,
                  color: '#111827',
                  lineHeight: 1.12,
                }}
              >
                Alur Beli Mobil BYD di BSD Serpong
              </Typography>
              <Typography sx={{ mt: 1.5, color: '#4b5563', lineHeight: 1.7 }}>
                Dari tanya harga sampai serah terima unit, prosesnya bisa
                dikonsultasikan langsung agar pilihan model, warna, dan skema
                pembayaran lebih jelas.
              </Typography>
            </Box>

            <Box
              component='ol'
              sx={{
                m: 0,
                p: 0,
                listStyle: 'none',
                display: 'grid',
                gap: 1.5,
              }}
            >
              {buyingSteps.map((step, index) => (
                <Box
                  component='li'
                  key={step}
                  sx={{
                    display: 'grid',
                    gridTemplateColumns: '44px 1fr',
                    gap: 1.5,
                    alignItems: 'start',
                    p: 2,
                    borderRadius: '8px',
                    backgroundColor: '#f8fafc',
                    border: '1px solid rgba(17,24,39,0.08)',
                  }}
                >
                  <Box
                    sx={{
                      width: 44,
                      height: 44,
                      borderRadius: '8px',
                      backgroundColor: '#2d6cdf',
                      color: '#fff',
                      display: 'grid',
                      placeItems: 'center',
                      fontWeight: 900,
                    }}
                  >
                    {index + 1}
                  </Box>
                  <Typography sx={{ color: '#111827', lineHeight: 1.6 }}>
                    {step}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          component='section'
          aria-labelledby='faq-byd-title'
          sx={{
            px: { xs: 2, md: 6 },
            py: { xs: 5, md: 7 },
            backgroundColor: '#f5f7fa',
          }}
        >
          <Box sx={{ maxWidth: 940, mx: 'auto' }}>
            <Typography
              id='faq-byd-title'
              component='h2'
              sx={{
                fontSize: { xs: '1.75rem', md: '2.3rem' },
                fontWeight: 900,
                color: '#111827',
                lineHeight: 1.12,
                mb: 2.5,
              }}
            >
              FAQ Dealer BYD BSD Serpong
            </Typography>
            <Box sx={{ display: 'grid', gap: 1.5 }}>
              {homeFaqs.map((faq) => (
                <Box
                  key={faq.question}
                  component='details'
                  sx={{
                    p: 2.2,
                    borderRadius: '8px',
                    backgroundColor: '#fff',
                    border: '1px solid rgba(17,24,39,0.08)',
                    '& summary': {
                      cursor: 'pointer',
                      fontWeight: 900,
                      color: '#111827',
                    },
                  }}
                >
                  <Box component='summary'>{faq.question}</Box>
                  <Typography sx={{ mt: 1.2, color: '#4b5563', lineHeight: 1.7 }}>
                    {faq.answer}
                  </Typography>
                </Box>
              ))}
            </Box>
          </Box>
        </Box>

        <Box
          component='section'
          aria-labelledby='brosur-byd-title'
          sx={{
            px: { xs: 2, sm: 4 },
            py: { xs: 5, md: 7 },
            backgroundColor: '#fff',
          }}
        >
          <Box sx={{ maxWidth: 1180, mx: 'auto' }}>
            <Typography
              id='brosur-byd-title'
              component='h2'
              sx={{
                mb: 1,
                fontSize: { xs: '1.75rem', md: '2.3rem' },
                fontWeight: 900,
                color: '#111827',
                lineHeight: 1.12,
              }}
            >
              Unduh Brosur Mobil Listrik BYD
            </Typography>
            <Typography variant='body2' sx={{ mb: 4, color: '#4b5563' }}>
              Dapatkan spesifikasi lengkap, fitur unggulan, dan pilihan warna
              untuk setiap model mobil listrik BYD. Klik untuk mengunduh brosur
              resmi dalam format PDF.
            </Typography>
            <Grid
              container
              spacing={3}
              justifyContent='center'
              alignItems='stretch'
            >
            {brochures.map((bro, idx) => {
              const isHot = bro.name === 'BYD Atto 1';
              return (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={3}
                  key={idx}
                  sx={{ height: '100%' }}
                >
                  <Box
                    component='a'
                    href={bro.file}
                    target='_blank'
                    rel='noopener noreferrer'
                    data-skip-react-snap
                    sx={{ textDecoration: 'none', color: 'inherit' }}
                  >
                    <Card
                      sx={{
                        position: 'relative',
                        height: '100%',
                        display: 'flex',
                        flexDirection: 'column',
                        justifyContent: 'flex-start',
                        alignItems: 'center',
                        textAlign: 'center',
                        p: 3,
                        borderRadius: '8px',
                        transition: 'all 0.3s ease-in-out',
                        boxShadow: 1,
                        backgroundColor: isHot ? '#ffeceb' : 'inherit',
                        '&:hover': {
                          backgroundColor: '#e2574c',
                          color: '#fff',
                          transform: 'scale(1.03)',
                        },
                      }}
                    >
                      {isHot && (
                        <Box
                          sx={{
                            position: 'absolute',
                            top: 8,
                            left: 8,
                            backgroundColor: '#e53935',
                            color: '#fff',
                            fontSize: 12,
                            fontWeight: 'bold',
                            px: 1,
                            py: 0.3,
                            borderRadius: '4px',
                            zIndex: 10,
                            animation: 'blinker 1s linear infinite',
                            boxShadow: '0 0 8px rgba(255,0,0,0.6)',
                            pointerEvents: 'none',
                          }}
                        >
                          HOT! NEW!
                        </Box>
                      )}

                      <Box
                        sx={{
                          display: 'inline-block',
                          backgroundColor: '#ff725e',
                          borderRadius: '8px',
                          p: 1,
                          mb: 2,
                        }}
                      >
                        <DescriptionIcon sx={{ fontSize: 40, color: '#fff' }} />
                      </Box>
                      <Typography variant='subtitle1' fontWeight='bold'>
                        Brosur {bro.name}
                      </Typography>
                      <Typography variant='body2' sx={{ mt: 1 }}>
                        Unduh brosur {bro.name} untuk melihat spesifikasi,
                        fitur, dan pilihan warna resmi.
                      </Typography>
                    </Card>
                  </Box>
                </Grid>
              );
            })}
            </Grid>
          </Box>
        </Box>
        <style>{`
          @keyframes scrollLeft {
            0% { transform: translateX(0); }
            100% { transform: translateX(-50%); }
          }

          @keyframes blinker {
            0% { opacity: 1; }
            50% { opacity: 0.2; }
            100% { opacity: 1; }
          }

          @media (prefers-reduced-motion: reduce) {
            #scrollable-cars > div {
              animation: none;
            }
          }
        `}</style>
      </Box>
    </>
  );
};

export default Body;
